import axios from "../../../../axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import PdfQTypeActivity from "../../On_going/Published/Published_Q_list/PublishQuestionType/PdfType/PdfQTypeActivity";
import { Form } from "react-bootstrap";
import "./ReviewCompleteStd.css";

const ReviewCompletedStudentData = () => {
  const { state } = useLocation();
  const [showDetails, setShowDetails] = useState(true);

  // 🔥 Get entryType and grade from state
  const entryType = state?.entryType || null;
  const obtainedGrade = state?.obtainedGrade || null;
  const gradeScale = state?.gradeScaleId || null;

  const [reviewCompleteData, setReviewCompleteData] = useState({
    reviewCompleteSdata: [],
    completedSList: [],
  });
  const { reviewCompleteSdata, completedSList } = reviewCompleteData;

  useEffect(() => {
    const getReviewCompletedActivity = async () => {
      try {
        const reviewCompleteSdata = await axios.get(
          `/api/v1/homework/activity/${state.reviewActivity_id}/studentResult/getByStudentAndActivityId/${state.student_id}`,
        );
        const completedSList = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${state.reviewActivity_id}?status=completed`,
        );

        reviewCompleteSdata &&
          completedSList &&
          setReviewCompleteData({
            reviewCompleteSdata: reviewCompleteSdata.data.data,
            completedSList: completedSList.data.data,
          });
      } catch (error) {}
    };
    getReviewCompletedActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const myList = [completedSList];
  const totalLength = myList
    .map((array) => array.length)
    .reduce((sum, length) => sum + length, 0);

  // Helper to get grade details from gradeScale
  const getGradeDetails = (grade) => {
    if (!gradeScale || !gradeScale.grades || !grade) return null;
    return gradeScale.grades.find((g) => g.grade === grade);
  };

  // Helper to get attachment display name
  const getAttachmentName = (attachment) => {
    if (!attachment) return "";
    if (attachment.startsWith("http://") || attachment.startsWith("https://")) {
      try {
        const url = new URL(attachment);
        const hostname = url.hostname.replace("www.", "");
        if (hostname.includes("youtube.com") || hostname.includes("youtu.be")) {
          return "YouTube Video";
        }
        if (hostname.includes("drive.google.com")) {
          return "Google Drive";
        }
        if (hostname.includes("docs.google.com")) {
          return "Google Docs";
        }
        return (
          hostname.split(".")[0].charAt(0).toUpperCase() +
          hostname.split(".")[0].slice(1)
        );
      } catch {
        return "Web Link";
      }
    }
    const ext = attachment.split(".").pop()?.toLowerCase();
    return ext ? ext.toUpperCase() : "File";
  };

  const attachformat = (para) => {
    if (para !== undefined) {
      const filePath = para;
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const lastUnderscoreIndex = fileName.lastIndexOf("_");
      if (lastUnderscoreIndex !== -1) {
        return fileName.substring(lastUnderscoreIndex + 1);
      } else {
        return fileName;
      }
    }
    return "";
  };

  // 🔥 Render result display - ONLY Grade OR Marks OR N/A
  const renderResult = () => {
    const obtainedMarks = reviewCompleteSdata?.obtained_marks;
    const totalMarks = reviewCompleteSdata?.total_marks;

    // 🔥 If entryType is "Grade" - show ONLY grade
    if (entryType === "Grade") {
      if (obtainedGrade) {
        const gradeDetails = getGradeDetails(obtainedGrade);
        const isPass = gradeDetails?.resultStatus === "Pass";

        return (
          <span
            style={{
              backgroundColor: isPass ? "#d4edda" : "#f8d7da",
              color: isPass ? "#155724" : "#721c24",
              padding: "6px 16px",
              borderRadius: "10px",
              fontSize: "1.3rem",
              fontWeight: 700,
            }}
          >
            {obtainedGrade}
          </span>
        );
      } else {
        return (
          <span
            style={{
              fontSize: "1.1rem",
              fontWeight: 600,
              color: "#94a3b8",
            }}
          >
            N/A
          </span>
        );
      }
    }

    // 🔥 If entryType is "Marks" - show ONLY marks
    if (entryType === "Marks") {
      if (obtainedMarks !== null && obtainedMarks !== undefined) {
        return (
          <span
            style={{
              fontSize: "1.3rem",
              fontWeight: 700,
              color: "#166534",
            }}
          >
            {obtainedMarks} / {totalMarks || 0}
          </span>
        );
      } else {
        return (
          <span
            style={{
              fontSize: "1.1rem",
              fontWeight: 600,
              color: "#94a3b8",
            }}
          >
            N/A
          </span>
        );
      }
    }

    // 🔥 If no entryType or entryType is "None" - show N/A
    return (
      <span
        style={{
          fontSize: "1.1rem",
          fontWeight: 600,
          color: "#94a3b8",
        }}
      >
        N/A
      </span>
    );
  };

  return (
    <>
      <div
        className="orange-scrollBar"
        style={{ overflowY: "auto", height: "600px" }}
      >
        {/* ═══════════════════════════════════════════════════
            MODERN HEADER
            ═══════════════════════════════════════════════════ */}
        <div className="d-flex align-items-center gap-3 w-100 mb-3">
          <NavLink
            to={`/StudentListActivity`}
            className="link"
            state={{ reviewActivity_id: state.reviewActivity_id }}
          >
            <div
              style={{
                cursor: "pointer",
                width: "36px",
                height: "36px",
                borderRadius: "10px",
                background: "#f1f5f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <img
                className="Pointer"
                src="/images/Back Arrow.svg"
                alt=""
                style={{ width: "18px" }}
              />
            </div>
          </NavLink>

          <div className="d-flex flex-column gap-1" style={{ flex: 1 }}>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 700,
                  color: "#1e293b",
                  lineHeight: 1.3,
                }}
              >
                {reviewCompleteSdata?.activity_id?.name || "Activity"}
              </span>
              <span
                style={{
                  background: "#dcfce7",
                  color: "#166534",
                  border: "1px solid #bbf7d0",
                  padding: "4px 12px",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  whiteSpace: "nowrap",
                }}
              >
                Completed
              </span>
              {/* 🆕 Entry Type Badge - only if not None */}
              {entryType && entryType !== "None" && (
                <span
                  style={{
                    background: entryType === "Grade" ? "#6366f1" : "#28a745",
                    color: "#fff",
                    padding: "4px 12px",
                    borderRadius: "999px",
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {entryType}
                </span>
              )}
            </div>
            <span className="fw-small text-muted" style={{ fontSize: "11px" }}>
              <Link to="/PublishedHomeworkActivity" className="link">
                <span style={{ color: "#64748b" }}>Completed</span>
              </Link>
              {" / "}
              <NavLink
                to={`/StudentListActivity`}
                className="link"
                state={{ reviewActivity_id: state.reviewActivity_id }}
              >
                <span style={{ color: "#64748b" }}>
                  {reviewCompleteSdata?.activity_id?.name}
                </span>
              </NavLink>
              {" / "}
              <span style={{ color: "#92400e", fontWeight: 600 }}>
                {reviewCompleteSdata?.student_response?.student_id?.name}
              </span>
            </span>
          </div>

          {/* 🔥 Result Badge - ONLY Grade OR Marks OR N/A */}
          <div
            className="d-flex flex-column align-items-center"
            style={{
              background:
                entryType === "Grade"
                  ? "#f5f3ff"
                  : entryType === "Marks"
                    ? "#f0fdf4"
                    : "#f8fafc",
              border:
                entryType === "Grade"
                  ? "2px solid #6366f1"
                  : entryType === "Marks"
                    ? "2px solid #86efac"
                    : "2px solid #e2e8f0",
              padding: "10px 20px",
              borderRadius: "12px",
              minWidth: "100px",
            }}
          >
            <span
              style={{
                fontSize: "0.7rem",
                color:
                  entryType === "Grade"
                    ? "#4338ca"
                    : entryType === "Marks"
                      ? "#166534"
                      : "#94a3b8",
                fontWeight: 600,
                textTransform: "uppercase",
              }}
            >
              {entryType === "Grade"
                ? "Grade"
                : entryType === "Marks"
                  ? "Result"
                  : "N/A"}
            </span>
            {renderResult()}
          </div>
        </div>

        <div className="mb-3">
          <span style={{ fontWeight: 600, color: "#475569" }}>
            {reviewCompleteSdata?.activity_id?.subject_id?.name}
          </span>
        </div>

        {/* ═══════════════════════════════════════════════════
            STUDENT ANSWER CARD (QUESTION SECTION)
            ═══════════════════════════════════════════════════ */}
        <div
          style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #e9ecef",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              fontSize: "0.8rem",
              fontWeight: 700,
              color: "#6c757d",
              textTransform: "uppercase",
              letterSpacing: "0.6px",
              marginBottom: "14px",
              borderBottom: "1px solid #dee2e6",
              paddingBottom: "8px",
            }}
          >
            📝 Student Answer
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <span
              style={{ fontWeight: 600, color: "#475569", fontSize: "14px" }}
            >
              Submitted Response
            </span>
            <span
              style={{
                background: "#dcfce7",
                color: "#166534",
                border: "1px solid #bbf7d0",
                padding: "4px 12px",
                borderRadius: "999px",
                fontSize: "0.75rem",
                fontWeight: 600,
              }}
            >
              {entryType === "Grade"
                ? "Grade Based"
                : entryType === "Marks"
                  ? `${reviewCompleteSdata?.total_marks || 0} Marks`
                  : "N/A"}
            </span>
          </div>

          <div
            className="p-3"
            style={{
              width: "100%",
              background: "#ffffff",
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
              marginBottom: "16px",
              whiteSpace: "pre-wrap",
              lineHeight: 1.7,
              color: "#475569",
              fontSize: "14px",
              minHeight: "80px",
            }}
          >
            {reviewCompleteSdata?.student_response?.description ||
              "No answer provided"}
          </div>

          {/* Student Attachments */}
          <div className="pdf_container_activity_review d-flex flex-wrap gap-2">
            {reviewCompleteSdata?.student_response?.attachments?.length !== 0 &&
              reviewCompleteSdata?.student_response?.attachments?.map(
                (attachments, idx) => (
                  <div key={idx} style={{ margin: "5px" }}>
                    <PdfQTypeActivity
                      publishedAttachData={reviewCompleteSdata}
                      attachments={attachments}
                    />
                  </div>
                ),
              )}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════
            TEACHER REVIEW CARD (ANSWER SECTION)
            ═══════════════════════════════════════════════════ */}
        <div
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid #d0d7de",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              fontSize: "0.8rem",
              fontWeight: 700,
              color: "#6c757d",
              textTransform: "uppercase",
              letterSpacing: "0.6px",
              marginBottom: "16px",
              borderBottom: "1px solid #dee2e6",
              paddingBottom: "8px",
            }}
          >
            ✍️ Teacher Review
          </div>

          {/* 🔥 Marks/Grade Obtained - ONLY one */}
          <div className="mb-3">
            <div className="mb-2" style={{ fontWeight: 600, color: "#475569" }}>
              {entryType === "Grade"
                ? "Grade Obtained:"
                : entryType === "Marks"
                  ? "Marks Obtained:"
                  : "Result:"}
            </div>

            {entryType === "Grade" && obtainedGrade ? (
              <div
                style={{
                  display: "inline-block",
                  background: "#f5f3ff",
                  border: "2px solid #6366f1",
                  padding: "10px 24px",
                  borderRadius: "10px",
                  fontSize: "1.2rem",
                  fontWeight: 700,
                  color: "#4338ca",
                }}
              >
                {obtainedGrade}
              </div>
            ) : entryType === "Marks" &&
              reviewCompleteSdata?.obtained_marks !== null &&
              reviewCompleteSdata?.obtained_marks !== undefined ? (
              <div
                style={{
                  display: "inline-block",
                  background: "#f0fdf4",
                  border: "2px solid #86efac",
                  padding: "10px 24px",
                  borderRadius: "10px",
                  fontSize: "1.2rem",
                  fontWeight: 700,
                  color: "#166534",
                }}
              >
                {reviewCompleteSdata?.obtained_marks} /{" "}
                {reviewCompleteSdata?.total_marks || 0}
              </div>
            ) : (
              <div
                style={{
                  display: "inline-block",
                  background: "#f8fafc",
                  border: "2px solid #e2e8f0",
                  padding: "10px 24px",
                  borderRadius: "10px",
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  color: "#94a3b8",
                }}
              >
                N/A
              </div>
            )}
          </div>

          {/* Teacher Comment */}
          <div className="mb-3">
            <div className="mb-2" style={{ fontWeight: 600, color: "#475569" }}>
              Teacher Comment:
            </div>
            <Form.Control
              as="textarea"
              value={reviewCompleteSdata?.comment || "No comment provided"}
              rows={4}
              className="px-3 py-2"
              readOnly
              style={{
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                resize: "none",
                color: "#475569",
              }}
            />
          </div>

          {/* Teacher Attachments */}
          <div className="mt-2 p-1 onreview_pdf_activity d-flex flex-wrap">
            {reviewCompleteSdata?.attachments &&
              reviewCompleteSdata?.attachments !== 0 &&
              reviewCompleteSdata?.attachments.map((attachment, index) => (
                <div key={index} style={{ margin: "5px" }}>
                  <PdfQTypeActivity attachments={attachment} />
                </div>
              ))}
          </div>

          {/* Correct Answer Section */}
          <div
            className="mb-2 mt-4"
            style={{ fontWeight: 600, color: "#475569" }}
          >
            Correct Answer:
          </div>
          <div
            className="d-flex align-items-center"
            style={{ width: "100%", marginBottom: "20px" }}
          >
            <input
              className="hw_add_reason"
              placeholder="Correct Answer"
              value={
                reviewCompleteSdata?.activity_id?.correctAnswer?.explanation ||
                ""
              }
              disabled={true}
              maxLength="250"
              style={{
                width: "100%",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                padding: "12px",
                color: "#475569",
              }}
            />
          </div>

          {/* Correct Answer Attachments */}
          <div className="mt-2 p-1 onreview_pdf_activity d-flex flex-wrap">
            {reviewCompleteSdata?.activity_id?.correctAnswer?.attachment &&
              reviewCompleteSdata?.activity_id?.correctAnswer?.attachment
                .length !== 0 &&
              reviewCompleteSdata?.activity_id?.correctAnswer?.attachment.map(
                (attachment, index) => (
                  <div key={index} style={{ margin: "10px" }}>
                    <PdfQTypeActivity attachments={attachment} />
                  </div>
                ),
              )}
          </div>
        </div>

        {/* Close Button */}
        <NavLink
          to={`/StudentListActivity`}
          className="link"
          state={{ reviewActivity_id: state.reviewActivity_id }}
        >
          <div
            className="mt-4 d-flex align-items-center justify-content-end"
            style={{ paddingBottom: "20px", marginRight: "0" }}
          >
            <button
              className="btn py-2 closeButtonActivity"
              type="button"
              style={{
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                padding: "8px 24px",
                fontWeight: 600,
              }}
            >
              Close
            </button>
          </div>
        </NavLink>
      </div>
    </>
  );
};

export default ReviewCompletedStudentData;
